import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Unprivileged from '../components/Pages/Unprivileged';
import { Loading } from '../components/UI/Common';

const PrivilegeComponent = ({ component: Component, props, rest }) => {
  const { permission } = rest;
  const { currentUserPermissions } = rest.permissions;
  if (currentUserPermissions === null) {
    return <Loading />;
  }
  if (
    currentUserPermissions.includes(permission) ||
    permission === 'Admin' ||
    permission === 'None'
  ) {
    return <Component {...props} />;
  } else {
    return <Unprivileged />;
  }
};

export const AuthRoute = ({ component: Component, ...rest }) => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const departmentSettings = JSON.parse(
    localStorage.getItem('departmentSettings'),
  );
  return (
    <Route
      {...rest}
      render={(props) => {
        return userInfo &&
          'access_token' in userInfo &&
          userProfile &&
          departmentSettings ? (
          <PrivilegeComponent component={Component} props={props} rest={rest} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        );
      }}
    />
  );
};
